export const FLAGS = {
    RED : 800
};